export function getCookie(name) {
    if (typeof document !== 'undefined') {
        var parts = ("; " + document.cookie).split("; " + name + "=");
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }
    return '';
}
//# sourceMappingURL=cookieUtils.js.map